module.exports = __webpack_public_path__ + "img/mo.a829e887.svg";